module.exports = __webpack_public_path__ + "media/images/icons/flags/LK-bbc1a8add8a8e4e21c4e4965704f8cb7.svg";